import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';

const engineeringMetricsPage = PageBlueprint.make({
  name: 'engineering-metrics',
  params: {
    path: '/engineering-metrics',
    loader: async () => {
      const { EngineeringMetricsPage } = await import(
        './EngineeringMetricsPage'
      );
      return <EngineeringMetricsPage />;
    },
  },
});

export const engineeringMetricsPlugin = createFrontendPlugin({
  pluginId: 'engineering-metrics',
  extensions: [engineeringMetricsPage],
});
